import '.ax{position:relative;}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.an{justify-content:center;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.bs{position:absolute;}.ssr-plugin'
import '.ch{top:0px;}.ssr-plugin'
import '.hu{right:-4px;}.ssr-plugin'
import '.ff{width:1.5rem;}.ssr-plugin'
import '.fg{height:1.5rem;}.ssr-plugin'
import '.au{border-radius:1.25rem;}.ssr-plugin'
import '.hv{background-color:var(--brand-primary);}.ssr-plugin'
import '.z{cursor:pointer;}.ssr-plugin'
import { Image } from '@app/components/core/image/Image'
import { faXmark } from '@fortawesome/pro-regular-svg-icons'
import { styled } from 'inlines'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashUndo } from '@fortawesome/pro-solid-svg-icons'

export const PreviewImage = ({
  src,
  isUploadPreview = false,
  onDelete,
  onCancelDelete,
}: {
  src: string
  isUploadPreview?: boolean
  onDelete?: () => void
  onCancelDelete?: () => void
}) => {
  const showDeleteButton = onDelete && !onCancelDelete
  const showCanceleDelete = onDelete && !!onCancelDelete
  return (
    <div className="ax d an r"
    >
      <Image
        onClick={onCancelDelete}
        src={src}
        resizeWidth={90}
        ignoreResize={isUploadPreview}
        style={{
          width: '5.625rem',
          height: '5.625rem',
          borderRadius: '1.25rem',
          objectFit: 'cover',
          objectPosition: 'center',
          aspectRatio: '1/1',
          flexShrink: 0,
          filter: showCanceleDelete ? 'brightness(50%)' : 'none',
        }}
      />
      {showDeleteButton && <RemoveImageIcon onClick={onDelete} />}
      {showCanceleDelete && (
        <FontAwesomeIcon
          onClick={onCancelDelete}
          icon={faTrashUndo}
          color="var(--palette-white)"
          fontSize={'3rem'}
          style={{ position: 'absolute' }}
        />
      )}
    </div>
  )
}

const RemoveImageIcon = ({ onClick }: { onClick: () => void }) => {
  return (
    <div className="d an r bs ch hu ff fg au hv z"
      onClick={onClick}
    >
      <FontAwesomeIcon icon={faXmark} color="var(--palette-white)" />
    </div>
  )
}
